import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'

type CopyPrintFormDialogProps = {
  isShow: boolean
  sourceTitle: string
  existingIds: string[]
  onClose: () => void
  onCopy: (newId: string, newTitle: string) => void
}

export const CopyPrintFormDialog: FC<CopyPrintFormDialogProps> = ({
  isShow,
  sourceTitle,
  existingIds,
  onClose,
  onCopy,
}) => {
  const { t } = useTranslation()
  const [newId, setNewId] = useState('')
  const [newTitle, setNewTitle] = useState(`${sourceTitle} (copy)`)

  const idError = existingIds.includes(newId) ? t('printForms.copy.idExists') : ''

  const handleSubmit = () => {
    if (!newId.trim() || idError) return
    onCopy(newId.trim(), newTitle.trim())
    setNewId('')
    setNewTitle('')
  }

  return (
    <Dialog fullWidth maxWidth='xs' open={isShow} onClose={onClose}>
      <DialogTitle>{t('printForms.copy.title')}</DialogTitle>
      <DialogContent
        sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: '16px !important' }}
      >
        <TextField
          required
          error={Boolean(idError)}
          helperText={idError}
          label={t('printForms.internalId')}
          value={newId}
          onChange={e => setNewId(e.target.value)}
        />
        <TextField
          label={t('printForms.titleField')}
          value={newTitle}
          onChange={e => setNewTitle(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('button.cancel')}</Button>
        <Button
          disabled={!newId.trim() || Boolean(idError)}
          variant='contained'
          onClick={handleSubmit}
        >
          {t('printForms.copy.submit')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
